import { combineReducers } from 'redux';
import { releaseManagementReducer } from "./release-management-reducer";
import { userManagementReducer } from './user-management-reducer';
import { auditLogReducer } from './audit-log-reducer';
import { mrtTableReducer } from './mrt-table-reducer';
import { reportReducer } from './report-reducer';
import { dateRangeReducer } from './date-range-reducer';
import { authorizationClaimsReducer } from './authorization-claims-reducer';

const rootReducer = combineReducers({
    releaseManagementReducer: releaseManagementReducer,
    userManagementReducer: userManagementReducer,
    auditLogReducer: auditLogReducer,
    mrtTableReducer: mrtTableReducer,
    reportReducer: reportReducer,
    dateRangeReducer: dateRangeReducer,
    authorizationClaimsReducer: authorizationClaimsReducer
})

export default rootReducer
